import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Dropdown } from '@components/atoms/Dropdown';
import { useCustomNavigate } from '@hooks/useCustomNavigate';
import { useData } from '@hooks/useData';

export const LanguagesDropdown: FC = () => {
    const { allLanguages } = useData();

    const { changeLanguage } = useCustomNavigate();
    const { i18n, t } = useTranslation();

    const translations = {
        buttonAriaLabel: t('languages-dropdown-component.button-aria-label'),
    };

    const handleChangeLanguage = (lang: string) => {
        changeLanguage(lang);
    };

    const languagesToDisplay = (allLanguages?.data || []).filter((language) => language.status === 'active');

    return (
        <>
            {languagesToDisplay && languagesToDisplay.length > 1 && (
                <Dropdown
                    buttonContent={
                        <Typography fontSize="12" tagVariant={TypographyTagVariants.span}>
                            {languagesToDisplay
                                .find((item) => item.language_code === i18n.language)
                                ?.language_code?.toUpperCase()}
                        </Typography>
                    }
                    buttonAriaLabel={translations.buttonAriaLabel}
                    position="center"
                    withToggle={true}
                    menuItems={languagesToDisplay.map((lang) => {
                        const languageCode = lang.language_code || '';
                        const flag = lang.image;
                        const description = lang.language_name || '';

                        return (
                            <button key={languageCode} onClick={() => handleChangeLanguage(languageCode)}>
                                <img src={flag} className="me-3" alt={languageCode} />
                                <Typography fontSize="12" tagVariant={TypographyTagVariants.span}>
                                    {description}
                                </Typography>
                            </button>
                        );
                    })}
                />
            )}
        </>
    );
};
